<template>
  <div class="app-container">
    <RouterView />
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  }
}
</script>
